import axios from 'axios';

// ✅ Always use relative API in production
const getBaseURL = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  if (!envUrl) return 'http://localhost:4000/api';
  
  // If the URL already ends with /api, don't add it again
  return envUrl.endsWith('/api') ? envUrl : `${envUrl}/api`;
};

const api = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// ✅ Restore token on page refresh
const token = localStorage.getItem('token') || localStorage.getItem('its-ticket-token');
if (token) {
  api.defaults.headers.common.Authorization = `Bearer ${token}`;
}

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    localStorage.setItem('token', token);
    localStorage.setItem('its-ticket-token', token);
  } else {
    delete api.defaults.headers.common.Authorization;
    localStorage.removeItem('token');
    localStorage.removeItem('its-ticket-token');
  }
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // console.error('[Booking API] Error:', error.response?.status, error.config?.url);
    if (error.response && error.response.status === 401) {
      // ONLY redirect if we are NOT in the middle of an SSO attempt
      const hasSSO = window.location.search.includes('sso_token') || window.location.hash.includes('sso_token');
      const isProfileRequest = error.config?.url?.includes('/auth/profile');

      if (!hasSSO && !isProfileRequest) {
        // console.log('[Booking API] 401 Unauthorized - Redirecting to login');
        // Token expired or invalid
        localStorage.removeItem('its-ticket-token');
        localStorage.removeItem('token');
        delete api.defaults.headers.common.Authorization;
        
        // Redirect to login page if not already there
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      } else {
        // console.log('[Booking API] 401 Unauthorized during SSO/Verification - Suppressing redirect');
      }
    }
    return Promise.reject(error);
  }
);

export default api;
